import PropTypes from 'prop-types'

import CreationInvitationHeader from 'components/common/CreationInvitationHeader'

const CreateAttackHead = ({ activeAttacksPresent, origin = '' }) => (
  <CreationInvitationHeader
    buttonText="New Attack"
    heading="Create a new attack."
    link={`/attacks/new/${origin ?? ''}`}
    subheading={
      activeAttacksPresent
        ? 'Have you tried scheduling an attack?'
        : 'No active attacks found.'
    }
  />
)

CreateAttackHead.propTypes = {
  activeAttacksPresent: PropTypes.bool,
  origin: PropTypes.string
}

export default CreateAttackHead
